import { IconInfo } from '@consta/icons/IconInfo'
import { IconKebab } from '@consta/icons/IconKebab'
import type { Props as ButtonProps } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { ProjectContextMenu } from '@core/components'
import cn from 'classnames'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'
import { useRef, useState } from 'react'

import { FavoriteButton } from '../../FavoriteButton'
import { ProjectSidebar } from '../../ProjectSidebar'
import type { ProjectDetailExtended } from '../../types'
import css from './IconsCell.css'

const buttonSettings: ButtonProps = {
  size: 's',
  view: 'clear',
  onlyIcon: true,
}

type StatusCellPropsType = {
  params: ProjectDetailExtended
  toggleFavorite: (projectId: ProjectId) => void
}

export const IconsCell: FC<StatusCellPropsType> = ({ params, toggleFavorite }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const kebabRef = useRef(null)

  const openMenu = () => {
    setIsMenuOpen(true)
  }
  const closeMenu = () => {
    setIsMenuOpen(false)
  }
  const openSidebar = () => {
    setIsSidebarOpen(true)
  }
  const closeSidebar = () => {
    setIsSidebarOpen(false)
  }

  const handleFavorite = () => {
    toggleFavorite(params.id)
  }
  const isFavoriteProject = params.isFavorite

  return (
    <div className={css.statusCell}>
      <div className={css.statusCellProjectRowControls}>
        <Button iconRight={IconInfo} onClick={openSidebar} {...buttonSettings} />
        <ProjectSidebar
          isSidebarOpen={isSidebarOpen}
          closeSidebar={closeSidebar}
          projectData={params}
        />
        <Button
          ref={kebabRef}
          className={css.statusCellProjectRowControlsRotated}
          iconRight={IconKebab}
          onClick={openMenu}
          {...buttonSettings}
        />
        <FavoriteButton
          className={cn({ [css.hide]: !isFavoriteProject })}
          isFavorite={isFavoriteProject}
          onClick={handleFavorite}
        />
        <ProjectContextMenu
          params={params}
          isContextMenuOpened={isMenuOpen}
          closeMenu={closeMenu}
          innerRef={kebabRef}
        />
      </div>
    </div>
  )
}
